import { useMutation, useQueryClient } from 'react-query';

import { createDigestReport as reportsCreate } from 'api/digestReports/createDigestReport';

const useCreateDigestReport = () => {
  const queryClient = useQueryClient();

  const {
    isSuccess,
    mutate: createDigestReport,
    isLoading,
  } = useMutation(reportsCreate, {
    onSuccess: () => {
      queryClient.invalidateQueries('digestReportsListPost');
    },
  });

  return {
    isSuccess,
    createDigestReport,
    isLoading,
  };
};

export default useCreateDigestReport;
